import { render, staticRenderFns } from "./ComponentGroupList.vue?vue&type=template&id=71c51bf7&scoped=true"
import script from "./ComponentGroupList.vue?vue&type=script&lang=js"
export * from "./ComponentGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c51bf7",
  null
  
)

export default component.exports